import React, { useState, useEffect, useCallback } from "react";
import "./Navbar.css";
import ani from "./images/anikielab.webp";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  /* ───────────────────────────────────────────
      OPTIMIZED SCROLL LISTENER (THROTTLED)
  ─────────────────────────────────────────── */
  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setScrolled(window.scrollY > 50);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  /* ───────────────────────────────────────────
      MENU TOGGLE: MEMOIZED FOR LESS RERENDERS
  ─────────────────────────────────────────── */
  const toggleMenu = useCallback(() => {
    setMenuOpen((prev) => !prev);
  }, []);

  const closeMenu = useCallback(() => {
    setMenuOpen(false);
  }, []);

  return (
    <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="navbar-container">

        {/* LOGO - LAZY LOAD + DECODE FAST */}
        <div className="logo">
          <img
            src={ani}
            alt="AnikieLab"
            loading="lazy"
            decoding="async"
          />
        </div>

        {/* HAMBURGER BUTTON */}
        <div
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={toggleMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* NAV LINKS */}
        <div className={`links ${menuOpen ? "open" : ""}`}>
          <a href="/" onClick={closeMenu}>Home</a>
          <a href="#about" onClick={closeMenu}>About</a>
          <a href="#service" onClick={closeMenu}>Services</a>
          <a href="#skillLabs" onClick={closeMenu}>Skill Lab</a>
          <a href="#contact" className="contact-btn" onClick={closeMenu}>
            Contact
          </a>
        </div>
      </div>
    </nav>
  );
}
